











































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./item_add.vue";
import Edit from "./item_edit.vue";

@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() optionId!: number;

  dispatchType = "options/items";

  deleteConfirmContent = "你确定要删除该配置项吗？";

  dispatchTypeDelete = "options/deleteitem";

  itemTypes: any[] = [
    { id: "1", name: "文本框" },
    { id: "2", name: "文本域" },
    { id: "3", name: "图片" }
  ];

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "名称", dataIndex: "item_label" },
    { title: "标识", dataIndex: "item_name" },
    { title: "类型", scopedSlots: { customRender: "item_type" } },
    { title: "值", scopedSlots: { customRender: "item_value" } },
    { title: "所属场馆", dataIndex: "stadium_name" },
    { title: "排序", dataIndex: "sortid" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData(
      {
        option_id: this.optionId
      },
      false
    );
  }
}
